<template>
  <div class="body">
    <div style="padding-top: 35px">
      <p class="title">下载聚销售 APP</p>
      <p class="subtitle">车增值产品服务掌舵者 </p>
    </div>
    <div class="downloadBtn" v-if="getMobileOperatingSystem() === 'HarmonyOS'" @click="downloadApp('harmonyos')">
      <img src="./images/harmonyOS.png" />
      <p class="subtitle">鸿蒙版下载</p>
    </div>
    <div class="downloadBtn" v-else-if="getMobileOperatingSystem() !== 'IOS'" @click="downloadApp('android')">
      <img src="./images/android.png" />
      <p class="subtitle">安卓版下载</p>
    </div>
    <div class="downloadBtn" v-else @click="downloadApp('ios')">
      <img src="./images/ios.png" />
      <p class="subtitle">IOS 下载</p>
    </div>

    <img src="./images/logo.png" class="logo" />
    <div class="tip" v-if="!is_weixn()">
      <img src="./images/zhiyin.png" />
    </div>
  </div>
</template>

<script>
import { getDownloadUrl } from "@/api/gjApi.js";
const HUAWEI_ANDROID_MARKET_URL =
  "appmarket://details?id=com.jurui.sellapp";
// 聚销售 AppStore 直链（后台没配时兜底用，不再依赖后台配置）
const IOS_APPSTORE_URL =
  "https://apps.apple.com/cn/app/%E8%81%9A%E9%94%80%E5%94%AE/id6736848996";
export default {
  data() {
    return {
      downloadData: {},
      userAgent: ""
    };
  },
  mounted() { },
  methods: {
    openAppStore(httpsUrl) {
      // https 直链 iOS 也能通过 Universal Link 进 App Store，
      // 转 itms-apps:// 可以更直接地唤起 App Store App（需放在点击事件里）
      const itmsUrl = httpsUrl.replace(/^https:\/\//i, "itms-apps://");
      window.location.href = itmsUrl;
      // 自定义 Scheme 被拦截/失败时，兜底用 https 再跳一次
      setTimeout(() => {
        window.location.replace(httpsUrl);
      }, 1200);
    },
    downloadApp(type) {
      if (type === "ios") {
        // 直接打开 AppStore 下载，不再弹框输入手机号
        // 例：https://apps.apple.com/cn/app/聚销售/idXXXXXXXXXX
        const httpsUrl = this.downloadData["ios"]?.downloadUrl || IOS_APPSTORE_URL;
        if (!httpsUrl) {
          this.$toast && this.$toast.fail("暂未获取到下载地址");
          return;
        }
        this.openAppStore(httpsUrl);
        return;
      }
      if (type === "harmonyos") {
        const url =
          this.downloadData["harmony"]?.downloadUrl ||
          this.downloadData["harmonyos"]?.downloadUrl ||
          "store://appgallery.huawei.com/app/detail?id=com.jurui.sellappohos";
        window.location.href = url;
        return;
      }
      if (type === "android" && this.isHuaweiCompatibleHarmonyOS()) {
        window.location.href = HUAWEI_ANDROID_MARKET_URL;
        return;
      }
      const url = this.downloadData[type]?.downloadUrl;
      if (!url) return;
      window.location.href = url;
    },
    is_weixn() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return false;
      } else {
        return true;
      }
    },
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      console.log(userAgent, "userAgent");
      this.userAgent = userAgent;
      if (
        userAgent.match(/iPhone/i) ||
        userAgent.match(/iPad/i) ||
        userAgent.match(/iPod/i) ||
        userAgent.match(/Macintosh/i) ||
        userAgent.match(/iOS/i)
      ) {
        return "IOS";
      }

      if (this.isHarmonyOSNextDevice()) {
        return "HarmonyOS";
      }

      if (
        userAgent.match(/Android/i) ||
        userAgent.match(/HarmonyOS/i) ||
        userAgent.match(/Harmony/i) ||
        userAgent.match(/ArkWeb/i)
      ) {
        return "Android";
      }

      return "unknown";
    },
    isHarmonyOSNextDevice() {
      const userAgent = this.userAgent || navigator.userAgent || "";
      const harmonyVersion = userAgent.match(
        /(?:OpenHarmony|HarmonyOS)[/\s](\d+(?:\.\d+)?)/i
      );
      const isHarmonyOSNext =
        userAgent.match(/HarmonyOS\s*-?\s*NEXT/i) ||
        userAgent.match(/OpenHarmony/i) ||
        (harmonyVersion && parseInt(harmonyVersion[1], 10) >= 5);

      return !!isHarmonyOSNext;
    },
    isHuaweiCompatibleHarmonyOS() {
      const userAgent = this.userAgent || navigator.userAgent || "";
      return Boolean(
        !this.isHarmonyOSNextDevice() &&
          (userAgent.match(/HarmonyOS/i) || userAgent.match(/HUAWEI/i))
      );
    },
  },
  async created() {
    const res = await getDownloadUrl({ code: "jubao" });
    // console.log(res, '===========res')
    if (!res.success) return;
    this.downloadData = res.content;
  },
};
</script>

<style scpoed>
.body {
  width: 100vw;
  height: 100vh;
  background: url("./images/bg.jpg") no-repeat;
  background-size: contain;
  background-position: top;
}

.title {
  font-size: 28px;
  color: #fff;
  text-align: center;
  /* color: #3a7df6; */
  /* margin-top: 40%; */
}

.subtitle {
  font-size: 22px;
  color: #fff;
  text-align: center;
  /* margin-top: 20px; */
}

.downloadBtn {
  width: 5rem;
  height: 1.2rem;
  border-radius: 1rem;
  left: 50%;
  transform: translateX(-50%);
  bottom: 3rem;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3a7df6;
}

.downloadBtn img {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 10px;
}

.logo {
  width: 4rem;
  position: fixed;
  bottom: 0.7rem;
  left: 50%;
  transform: translateX(-50%);
}

.tip {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  /* align-items: center; */
  justify-content: center;
  padding-top: 80px;
}

.tip img {
  width: 100%;
  height: 240px;
}
</style>


